export default __webpack_public_path__ + "static/media/ES Website Development & Digital Marketing (1).a866c973.jpg";